import React from 'react';
import {Form} from "react-final-form";
import {Select, TextField} from "mui-rff";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core/styles";
import validate from "validate.js";
import axios from "axios";
import {API_URL} from "../../config";
import CircularProgress from "@material-ui/core/CircularProgress";
import createDecorator from "final-form-focus";
import { useHistory } from "react-router-dom";
import CustomError from "../../helpers/CustomError";
import {handleError} from "../../helpers/errorHandler";

const useStyles = makeStyles(theme => ({
    buttonWrapper: {
        marginTop: 16
    },
    textField: {
        marginBottom: theme.spacing(2),
    },
    formControl: {
        marginBottom: theme.spacing(2),
        marginRight: theme.spacing(2),
        width: '100%',
    },
}));

const RecoverPasswordForm = ({ initialValues, roles, onSuccess, onError, onLoadingChange, submitting }) => {

    const classes = useStyles();

    const history = useHistory();

    const focusOnErrors = createDecorator();

    // Reglas de validación de formulario
    const constraints = {
        auth_code: {
            presence: {
                allowEmpty: false,
                message: 'Debe de llenar este campo'
            },
            numericality: {
                onlyInteger: true,
                message: 'Solo debe de ingresar números'
            }
        }
    };

    // Función que se ejecuta al enviar formulario
    async function onSubmit(values, form) {

        // Mostrar indicador de carga
        onLoadingChange(true);

        try {

            // Hacer request
            const response = await axios.post(
                `${API_URL}/kiosko/v1/ConfirmReset`,
                {
                    auth_code: values.auth_code,
                    uid: values.uid
                }
            );

            if(response.data.status !== 'Success'){
                throw new CustomError(response.data.message, 'custom');
            }

            const cid = response.data.data.cid;

            // Enviar mensaje de éxito
            onSuccess('Ha verificado su identidad exitosamente.');

            history.push('/password', {uid: values.uid, cid});

            // Esconder indicador de carga
            onLoadingChange(false);


        } catch (error) {

            // Esconder indicador de carga
            onLoadingChange(false);

            if(!error.response){
                onError(handleError('network', 'No hay conexión a internet.'));
            } else if(error.status === 'custom'){
                onError(handleError('custom', error.message));
            } else {
                if(error.response.data && error.response.data.message)
                    onError(handleError('custom', error.response.data.message));
                else
                    onError(handleError(error.response.status));
            }

        }

    }

    // Función que valida el formulario
    async function validateForm(values) {

        // Validar campos
        let valid = validate({...values}, constraints, {fullMessages: false});

        // Si no hay error
        if(!valid)
            return;
        else {

            // Modificar objeto para mostrar errores en formulario
            Object.keys(valid).forEach((key, index) => {
                valid[key] = valid[key][0];
            });

            return valid;
        }
    }

    return (
        <Form
            onSubmit={onSubmit}
            initialValues={initialValues}
            decorators={[ focusOnErrors ]}
            validate={validateForm}
            render={({ handleSubmit, values, submitError, form }) => (
                <form onSubmit={handleSubmit} noValidate>
                    <TextField label="Código" name="auth_code" />
                    <div className={ classes.buttonWrapper }>
                        <Button fullWidth color="primary" type="submit" variant="contained" disabled={submitting} startIcon={ submitting ? <CircularProgress size={18}/> : null }>Recuperar</Button>
                    </div>
                </form>
            )}
        />
    );
};

export default RecoverPasswordForm;
